// store.js
import { create } from "zustand"
import { persist, devtools } from "zustand/middleware"

const useProjectStore = create(
	devtools(
		(set) => ({
			genStatus: 0,

			aimodel: "latentsync",
			ailoopmode: "pingpong",
			isPublic: true,

			creditsNeeded: 0,

			projVideo: {
				type: "upload",
				source: null,
				name: "",
				width: 0,
				height: 0,
				duration: 0,
				size: 0
			},

			projAudio: {
				type: "upload", // "upload" | "tts" | "record"
				source: null, // Blob URL for preview
				name: "",
				duration: 0,
				file: null // File object for upload to R2
			},

			// TTS 音色选择
			selectedVoice: {
				voice_id: "21m00Tcm4TlvDq8ikWAM", // 默认音色 Rachel
				name: "Rachel",
				labels: {
					gender: "female",
					language: "en"
				}
			},

			setGenStatus: (status) => set({ genStatus: status }),
			set_AiModel: (model) => set({ aimodel: model }),
			set_AiLoopMode: (mode) => set({ ailoopmode: mode }),
			setCreditsNeeded: (credits) => set({ creditsNeeded: credits }),
			setProjVideo: (video) => set({ projVideo: video }),
			setProjAudio: (audio) => set({ projAudio: audio }),
			set_isPublic: (isPublic) => set({ isPublic: isPublic }),
			setSelectedVoice: (voice) => set({ selectedVoice: voice }),
			// 你可以添加更多状态和 actions

			resetProjectStore: () =>
				set({
					genStatus: 0,
					aimodel: "latentsync",
					ailoopmode: "pingpong",
					isPublic: true,
					creditsNeeded: 0,
					projVideo: {
						type: "upload",
						source: null,
						name: "",
						width: 0,
						height: 0,
						duration: 0,
						size: 0
					},
					projAudio: {
						type: "upload",
						source: null,
						name: "",
						duration: 0,
						file: null
					},
					selectedVoice: {
						voice_id: "21m00Tcm4TlvDq8ikWAM",
						name: "Rachel",
						labels: {
							gender: "female",
							language: "en"
						}
					}
				})
		}),
		{
			name: "project-store"
		}
	)
)

export default useProjectStore
